import { render, staticRenderFns } from "./ControlRowCol.vue?vue&type=template&id=523bf4be&scoped=true"
import script from "./ControlRowCol.vue?vue&type=script&lang=ts"
export * from "./ControlRowCol.vue?vue&type=script&lang=ts"
import style0 from "./ControlRowCol.vue?vue&type=style&index=0&id=523bf4be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523bf4be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('523bf4be')) {
      api.createRecord('523bf4be', component.options)
    } else {
      api.reload('523bf4be', component.options)
    }
    module.hot.accept("./ControlRowCol.vue?vue&type=template&id=523bf4be&scoped=true", function () {
      api.rerender('523bf4be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cards/controltable/ControlRowCol.vue"
export default component.exports